// extracted by mini-css-extract-plugin
module.exports = {"Description":"Footer_Description__3h80a"};